module.exports = __webpack_public_path__ + "img/icon-number.31c64833.svg";